import React from "react";

export default function PaymentListing({ previousPayments }) {
  return (
    <>
      {previousPayments?.map((payment, index) => (
        <div className="card mb-2" key={index}>
          <div className="card-body">
            <div className="row">
              <div className="col-sm-6">
                Amount Paid (₹) : <b>{payment?.amountPaid || 'N/A'}</b>
              </div>
              <div className="col-sm-6">
                Reference Number : <b>{payment?.referenceNumber}</b>
              </div>
              {payment?.paymentDate && (
                <div className="col-sm-6">
                  Payment Date : <b>{payment?.paymentDate}</b>
                </div>
              )}
              {payment?.grnNumber && (
                <div className="col-sm-6">
                  Bank Reference Number : <b>{payment?.grnNumber}</b>
                </div>
              )}
              {payment?.paymentMode && (
                <div className="col-sm-6">
                  Payment Mode : <b>{payment?.paymentMode.slice(3)}</b>
                </div>
              )}
              <div className="col-sm-6">
                Status :{" "}
                <span
                  style={{
                    color:
                      payment.status === "FAILURE"
                        ? "#dc3545"
                        : payment.status === "SUCCESS"
                        ? "#198754"
                        : payment.status === "PENDING"
                        ? "#ffc107"
                        : "black",
                    fontWeight: "bold",
                  }}
                >
                  {payment.status}
                </span>
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
}
